export default __webpack_public_path__ + "media/images/users/user-eva-pool-270x320-37701fc1cccffb299df1eb4e38d28fc4.jpg";